
export interface Action {
  type: string;
  state: string;
}

export const onboardingActions = {
  SET_ONBOARDING_STEPS : 'SET_ONBOARDING_STEPS',
  UPDATE_ONBOARDING_STEPS : 'UPDATE_ONBOARDING_STEPS',
  UPDATE_VISITED_STEPS: 'UPDATE_VISITED_STEPS'
}
export const setOnboardingSteps = (action: string, data: any): Action => ({
  type: action,
  state: data,
});
